import EditDetailsForm from './EditDetailsForm'
import enhance from './EditDetailsForm.enhancer'

export default enhance(EditDetailsForm)



// WEBPACK FOOTER //
// ./src/components/organisms/EditDetailsForm/index.js